import { FormControl } from 'react-bootstrap';
import { TaskInStack } from './TaskInStack';
import { StackColumnButtons } from './StackColumnButtons';
import styled from 'styled-components';

const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px;
  min-width: 520px;
  flex: 1;
`;

const Queue = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px;
  justify-content: center;
`;

function StackColumn(props) {
  const {
    stack,
    filter,
    blockedFilter,
    onTitleChange,
    moveLastToTop,
    shuffleTasks,
    sortByCompletionTime,
    addTaskToStack,
    editTask,
    completeTask,
    moveCurrentToBottom,
    splitTaskToStack,
  } = props;

  const visibleTasks = stack.tasks.filter((t) => {
    if (blockedFilter && t.blocked) {
      return false;
    }
    if (filter === "") {
      return true;
    }
    return t.tags.includes(filter) || t.description.includes(filter);
  });

  return <Column data-cy="stack-column">
    <FormControl style={{ textAlign: "center" }} data-cy="stack-title"
      required
      placeholder="Stack title"
      aria-label="stack title"
      value={stack.title}
      onChange={(e) => onTitleChange(e.target.value)}
    />
    <Queue data-cy="queue" id={"queue-" + stack.id}>
      {
        visibleTasks.map((task) =>
          <TaskInStack
            splitTaskToStack={splitTaskToStack}
            key={task.taskId + task.tags}
            task={task}
            editTask={editTask}
            completeTask={completeTask}
            moveCurrentToBottom={moveCurrentToBottom}
          />
        )
      }
    </Queue>
    <StackColumnButtons
      addTaskToStack={addTaskToStack}
      moveLastToTop={moveLastToTop}
      shuffleTasks={shuffleTasks}
      sortByCompletionTime={sortByCompletionTime}
      timeleft={stack.timeleft}
    />
  </Column>;
}

export { StackColumn };
